import React from "react";
import styles from "./Title.module.scss";

const Title = () => {
  return (
    <div id="home" className={styles.header__text}>
      <h1>tea milas</h1>
      <h2>software developer</h2>
    </div>
  );
};

export default Title;
